import { useContext } from 'react';

import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    Stack,
    Typography,
    useTheme,
} from '@mui/material';
import { styled } from '@mui/material/styles';

import { AnalyticsContext } from 'src/AnalyticsContext';
import TrainingButtonGif from 'src/assets/images/training/button-press-animated.gif';
import useAlertTraining from 'src/hooks/useAlertTraining';

interface TrainingCareConfirmationDialogProps {
    open: boolean;
    onClose: () => void;
}

const StyledDialog = styled(Dialog)({
    '& .MuiDialog-container': {
        alignItems: 'flex-start',
        justifyContent: 'center',
    },
    '.MuiPaper-root': {
        backgroundImage: `url(${TrainingButtonGif})`,
        backgroundSize: '100% auto',
        backgroundPosition: 'top',
        backgroundRepeat: 'no-repeat',
        paddingTop: '250px',
        maxWidth: '300px',
    },
});

function TrainingCareConfirmationDialog(props: TrainingCareConfirmationDialogProps) {
    const { open, onClose } = props;
    const { confirmTrainingAlert } = useAlertTraining();

    const { palette } = useTheme();
    const { trackEvent } = useContext(AnalyticsContext);

    const handleTrainingAlertConfirmation = () => {
        confirmTrainingAlert();
        onClose();
        trackEvent('Training Alert Care Confirmed');
    };

    return (
        <StyledDialog open={open}>
            <DialogContent sx={{ paddingTop: 0 }}>
                <Stack sx={{ gap: 2, alignItems: 'center' }}>
                    <Typography variant="body2" component="p">
                        To resolve an alert, confirm you&apos;re with the resident by pressing their
                        pendant or unit button.
                    </Typography>
                </Stack>
            </DialogContent>
            <DialogActions sx={{ padding: 2.5, paddingTop: 0 }}>
                <Button
                    variant="contained"
                    disableElevation
                    fullWidth
                    onClick={handleTrainingAlertConfirmation}
                    sx={{ background: palette?.cyan?.[500], color: palette?.common?.white }}
                >
                    Confirm Care
                </Button>
            </DialogActions>
        </StyledDialog>
    );
}

export default TrainingCareConfirmationDialog;
